<template>
    <footer
        class="md-footer layout5"
        :class="[{ inner: inner }]"
        :style="{
            ...colorStyle,
            ...spaceStyle,
            ...bgImage
        }"
    >
        <div class="f-col footer-container">
            <div class="site-logo" v-if="logos.length > 0">
                <template v-for="(logo, index) in validLogos">
                    <a
                        v-if="logo.logo.href"
                        :key="index"
                        :href="logo.logo.href"
                        aria-label="site logo"
                        rel="noopener noreferrer"
                    >
                        <site-img
                            class="logo-item"
                            :src="logo.logo"
                            alt="site logo"
                            :style="{ height: size / 100 + 'em' }"
                            :ssrInitSize="30"
                            dir="height"
                        />
                    </a>
                    <site-img
                        v-else
                        class="logo-item"
                        :key="'key-' + index"
                        :src="logo.logo"
                        alt="site logo"
                        :style="{ height: size / 100 + 'em' }"
                        :ssrInitSize="30"
                        dir="height"
                    />
                </template>
            </div>
            <div v-if="socialNetworksInfo.length > 0" class="share-links">
                <a
                    v-for="(social, index) in socialNetworksInfo"
                    :key="social.id + '-' + index"
                    class="share-item"
                    :href="social.url"
                    :aria-label="social.socialNetwork"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i class="iconfont" :class="social.icon"></i>
                </a>
            </div>
            <div class="detail">
                <div
                    v-if="companyInfo?.name"
                    class="site-title"
                    :style="footerBroNameStyle"
                    v-html="companyInfo.name"
                ></div>
                <div
                    v-if="agentName"
                    class="site-title"
                    :style="footerAgentInfoStyle"
                    v-text="agentName"
                ></div>
                <div
                    v-if="getAddressInfo"
                    class="detail-addr site-p"
                    :style="footerBroAddrStyle"
                    v-html="getAddressInfo"
                ></div>
                <p
                    v-if="!!footerAgentInfo.phone"
                    class="site-p underline"
                    :style="footerAgentInfoStyle"
                >
                    <a
                        :href="'tel:' + footerAgentInfo.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        {{ $ft.formatPhone(footerAgentInfo.phone) }}
                    </a>
                </p>
                <p
                    v-if="!!footerAgentInfo.email"
                    class="site-p underline"
                    :style="footerAgentInfoStyle"
                >
                    <a
                        :href="'mailto:' + footerAgentInfo.email"
                        :title="$t('common:link.mailtoTitle')"
                        :aria-label="
                            $t('common:link.mailtoAriaLabel', {
                                email: footerAgentInfo.email
                            })
                        "
                        rel="noopener noreferrer"
                    >
                        {{ footerAgentInfo.email }}
                    </a>
                </p>
            </div>
            <div v-if="subOwnerName" class="detail">
                <div class="site-title" v-text="subOwnerName"></div>
                <p v-if="!!subOwnerInfo.phone" class="site-p underline">
                    <a
                        :href="'tel:' + subOwnerInfo.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        {{ $ft.formatPhone(subOwnerInfo.phone) }}
                    </a>
                </p>
                <p v-if="!!subOwnerInfo.email" class="site-p underline">
                    <a
                        :href="'mailto:' + subOwnerInfo.email"
                        :title="$t('common:link.mailtoTitle')"
                        :aria-label="
                            $t('common:link.mailtoAriaLabel', {
                                email: subOwnerInfo.email
                            })
                        "
                        rel="noopener noreferrer"
                    >
                        {{ subOwnerInfo.email }}
                    </a>
                </p>
            </div>
            <div class="detail other-cont">
                <template v-if="agentHasDisclaimer">
                    <p
                        v-for="(file, index) in footerAgentInfo.disclaimerList"
                        :key="index + 'mainfile'"
                        class="site-p detail-file"
                    >
                        <a :href="file.url" rel="noopener noreferrer">
                            {{ file.name.split('.')[0] }}
                        </a>
                    </p>
                </template>
                <template v-if="subOwnerHasDisclaimer">
                    <p
                        v-for="(file, index) in subOwnerInfo.disclaimerList"
                        :key="index + 'subfile'"
                        class="site-p detail-file"
                    >
                        <a :href="file.url" rel="noopener noreferrer">
                            {{ file.name.split('.')[0] }}
                        </a>
                    </p>
                </template>
                <div
                    v-if="footerAgentCustomContent"
                    class="site-p"
                    v-html="formatFontSize(footerAgentCustomContent)"
                ></div>
            </div>
            <closely-app-download useModule="md-header" :downloadTheme="true" />
            <div class="bottom-content">
                <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                    <a
                        href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                        target="_blank"
                        :title="$t('md-footer.realEstateConsumer')"
                        rel="noopener noreferrer"
                    >{{ $t('md-footer.realEstateConsumer') }}</a>
                </div>
                <div
                    class="no-mls-disclaimer"
                    v-if="noMlsDisclaimers.length > 0"
                >
                    <div
                        class="claimer"
                        v-for="(noMls, index) in noMlsDisclaimers"
                        :key="index"
                        v-html="noMls.label"
                    ></div>
                </div>
                <MlsDisclaimer v-if="!wordPressSSR" @update="mlsUpdated" />
            </div>
            <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --&gt; </a>
            <div v-if="!hideCopyRight" class="copyright">
                <template v-if="gfFlag != '1'">
                    <p class="site-p tip-color">
                        <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                    </p>
                    <p
                        class="site-p tip-color"
                        v-if="showCopyright"
                        v-html="
                            $t('md-footer.madeInAndCopyright', {
                                chimeLink,
                                year
                            })
                        "
                    ></p>
                </template>
                <p v-else class="site-p tip-color">
                    {{ $t('md-footer.geographicFarmingLlc', { year })
                    }}<CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index-layout';
import util from '@/common/util';
import { transformSrc } from '@/components/global/site-img.js';

export default {
    name: 'MdFooterLayout5',
    mixins: [common],
    computed: {
        bgImage() {
            let src = util.getImgSrcByPlatform(this.pictureOption, this.isMobile);
            let srcUrl = src?.imgUrl || src || '';
            srcUrl = transformSrc({ src: srcUrl, isMobile: this.isMobile });
            return srcUrl
                ? {
                    'background-image': `url("${srcUrl}")`
                }
                : {};
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../index.scss';

.md-footer.layout5 {
    position: relative;
    background: center center no-repeat;
    background-size: cover;
    &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: var(--bg-color);
    }
    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
    &.inner {
        .footer-container {
            padding: 0 var(--inner-padding, 20px);
        }
    }
    .footer-container {
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .site-logo {
        font-size: 50px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 30px;
        column-gap: 30px;
        .logo-item {
            display: block;
            height: 1em;
        }
    }
    .share-links {
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 10px;
        column-gap: 10px;
        .share-item {
            opacity: 0.8;
            line-height: 1;
            width: 30px;
            height: 30px;
            text-align: center;
            border-radius: 50%;
            border: 1px solid var(--g-primary-color);

            &:hover {
                opacity: 1;
                .iconfont {
                    color: var(--g-primary-color);
                }
            }
            .iconfont {
                font-size: 12px;
                line-height: 28px;
                color: var(--g-tip-color);
            }
        }
    }
    .detail {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .site-p {
            margin-top: 15px;
            text-align: center;
        }
        .detail-addr {
            margin-top: 10px;
        }
    }
    .site-p {
        margin-top: 15px;
        font-size: 14px;
    }
    .site-title {
        margin-top: 10px;
        font-size: 24px;
        text-align: center;
        font-weight: 700;
    }
    .other-cont {
        margin-top: 5px;
    }
    .detail-file {
        cursor: pointer;
        color: #797e8b;
    }
    .underline {
        text-decoration: underline;
    }
    .download-closely {
        margin-top: 30px;
        .code-title.down {
            margin-top: 10px;
            color: var(--g-text-color);
        }
        .download-link {
            text-align: center;
        }
        .code-wrapper {
            .qr-code {
                border-radius: 0;
            }
        }
    }
    .mls-declaimer-container .declaimer {
        padding-bottom: 20px;
    }
    .bottom-content {
        margin-top: 18px;
        @include no-mls-disclaimer;
        .no-mls-disclaimer {
            text-align: center;
            color: var(--g-text-color);
        }
    }
    .copyright {
        margin-top: 30px;
        padding-top: 15px;
        text-align: center;
        border-top: 1px solid rgba(218, 218, 218, 0.5);
        display: flex;
        justify-content: space-between;
        .cr {
            a {
                text-decoration: underline;
            }
        }
        .tip-color {
            color: var(--g-tip-color);
        }
        a {
            white-space: nowrap;
        }
    }

    @include media-600 {
        .site-title {
            font-size: 18px;
        }
        .site-p {
            font-size: 12px;
        }
        .copyright {
            flex-direction: column;
        }
    }
}
</style>
